import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Layout = ({ children }) => {
  const { currentUser } = useAuth();
  const location = useLocation();

  // Check if current route is property-related
  const isPropertyRoute = location.pathname === '/' || 
                         location.pathname.startsWith('/property/') || 
                         location.pathname.startsWith('/scenario/');
  const isDashboardsRoute = location.pathname === '/dashboards';
  const isSettingsRoute = location.pathname === '/settings';

  return (
    <div className="d-flex flex-column min-vh-100">
      {/* Horizontal Navigation Bar */}
      <div style={{ position: 'sticky', top: 0, zIndex: 1000, backgroundColor: '#1f2028', borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
        <div className="container-fluid px-3">
          <div className="d-flex align-items-center py-2" style={{ height: '48px' }}>
            {/* Logo/Brand */}
            <div className="me-4">
              <h5 className="text-light mb-0 fw-bold" style={{ fontSize: '1.1rem' }}>RE Calc</h5>
            </div>
            
            {/* Navigation Links */}
            <nav className="nav me-auto">
              <Link 
                to="/" 
                className="nav-link px-3 py-1 d-flex align-items-center text-light me-2"
                style={{ 
                  fontWeight: isPropertyRoute ? '500' : '400',
                  fontSize: '0.9rem'
                }}
              >
                <i className="bi bi-house-door me-1" style={{ fontSize: '0.85rem' }}></i>
                Properties
              </Link>
              <Link 
                to="/settings" 
                className="nav-link px-3 py-1 d-flex align-items-center text-light me-2"
                style={{ 
                  fontWeight: isSettingsRoute ? '500' : '400',
                  fontSize: '0.9rem'
                }}
              >                
                <i className="bi bi-gear me-1" style={{ fontSize: '0.85rem' }}></i>
                Settings
              </Link>
            </nav>
            
            {/* Profile Section */}
            <Link 
              to="/profile" 
              className="d-flex align-items-center text-decoration-none"
            >
              {/* Profile avatar circle */}
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px', backgroundColor: '#2a2d36', border: '1px solid rgba(255,255,255,0.2)' }}
              >
                <span className="text-light">
                  {currentUser?.email?.charAt(0).toUpperCase() || 'U'}
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="flex-grow-1" style={{ 
        background: '#1f2028',
        minHeight: '100vh'
      }}>
        {children}
      </div>
    </div>
  );
};

export default Layout;
